export const ISC_URL = `${window.location.origin}/new/2023/isc.html`
export const Active = {
  key: 'active',
  router: '/header-active'
}
